import React from 'react'
import { Text } from '@babylon/medkit'
import styles from './StepTitle.module.scss'

type StepTitleProps = {
  title: string
  subtitle: string
}

const StepTitle: React.FC<StepTitleProps> = ({ title, subtitle }) => (
  <div className={styles.titleContainer}>
    <Text variant="h4" tag="h1">
      {title}
    </Text>
    <Text variant="body">{subtitle}</Text>
  </div>
)

export default StepTitle
